import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class AyudaService {
    
    constructor(public http: HttpClient) { }


}